import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls to the top of the page whenever the route (pathname) changes.
// Fixes the issue where navigating from a long page lands mid-page on the next route.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use 'auto' (instant) so users never see a partial scroll animation on nav.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
